export default function ContentBlocks({ blocks = [] }) {
  if (!blocks || blocks.length === 0) return null;
  return (
    <div className="prose-edit">
      {blocks.map((b, i) => {
        switch (b.type) {
          case "heading":
            if (b.level === 3) return <h3 key={i}>{b.text}</h3>;
            return <h2 key={i}>{b.text}</h2>;
          case "paragraph":
            return <p key={i}>{b.text}</p>;
          case "quote":
            return (
              <blockquote key={i}>
                <span>"{b.text}"</span>
                {b.author && <footer className="mt-3 text-sm not-italic font-sans-edit text-cc-muted tracking-wide">{b.author}</footer>}
              </blockquote>
            );
          case "list":
            if (b.style === "ol") return <ol key={i}>{(b.items || []).map((it, j) => <li key={j}>{it}</li>)}</ol>;
            return <ul key={i}>{(b.items || []).map((it, j) => <li key={j}>{it}</li>)}</ul>;
          case "callout":
            return (
              <div key={i} className="my-8 p-6 border-l-2 border-cc-sepia bg-cc-bg/60">
                <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-2">
                  {b.variant === "tip" ? "İpucu" : b.variant === "warning" ? "Dikkat" : "Not"}
                </div>
                <p className="text-cc-text leading-relaxed m-0">{b.text}</p>
              </div>
            );
          case "image":
            return (
              <figure key={i} className="my-10">
                <img src={b.url || b.media_url} alt={b.alt || b.caption || ""} className="w-full" />
                {b.caption && <figcaption className="text-xs text-cc-muted mt-2 text-center italic">{b.caption}</figcaption>}
              </figure>
            );
          case "gallery":
            return (
              <div key={i} className="grid grid-cols-2 gap-3 my-10">
                {(b.urls || []).map((u, j) => <img key={j} src={u} alt="" className="w-full aspect-square object-cover" />)}
              </div>
            );
          case "embed":
            if (b.provider === "youtube") {
              return (
                <div key={i} className="my-10 aspect-video">
                  <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${b.id}`} title="Embed" allowFullScreen />
                </div>
              );
            }
            return null;
          case "cta":
            return (
              <div key={i} className="my-10">
                <a href={b.url} className="cc-btn">{b.label}</a>
              </div>
            );
          default:
            return null;
        }
      })}
    </div>
  );
}
